var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubirArchivo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 2.66634H3.33333V13.333H12.6667V5.33301H10V2.66634ZM2 1.99434C2 1.62901 2.298 1.33301 2.666 1.33301H10.6667L14 4.66634V13.995C14.0006 14.0826 13.984 14.1694 13.951 14.2505C13.9181 14.3316 13.8695 14.4054 13.808 14.4678C13.7466 14.5301 13.6734 14.5797 13.5928 14.6138C13.5121 14.6479 13.4255 14.6657 13.338 14.6663H2.662C2.48692 14.6651 2.31934 14.5951 2.19548 14.4713C2.07161 14.3476 2.0014 14.1801 2 14.005V1.99434ZM8.66667 7.99967V10.6663H7.33333V7.99967H5.33333L8 5.33301L10.6667 7.99967H8.66667Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubirArchivo);
export default __webpack_public_path__ + "static/media/subirArchivo.c6b6daba9f8ac0811bf7eac72f7cbfeb.svg";
export { ForwardRef as ReactComponent };